// import { app } from '../../../main';
import lang from '../../../lang/lang';

const getters = {
  getLang: state => {
    return lang.locale;
  },
  getShortLang: state => {
    return lang.locale.substr(lang.locale.length - 2).toLowerCase();
  },
  getLongLang: state => {
    let browserCountryDetection = (function(code) {
      switch(code) {
        case 'es-CL':
          return 'chile';
        case 'es-MX':
          return 'mexico';
        case 'es-AR':
          return 'argentina';
        case 'es-ES':
          return 'espana';
        case 'en-US':
          return 'eeuu';
        case 'pt-BR':
          return 'brasil';
        default:
          return 'chile'; // default
      }
    })(lang.locale);

    return browserCountryDetection;
  },
}

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/lang/getters.js